import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const cronJobsService = {
  _main_url: process.env.REACT_APP_AUTH_API_URL,

  GetJobsList(fetch) {
    const [data, setsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllJobs())
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [fetch]);

    return {
      _jobs_loading: status === STATUS.LOADING,
      _jobs_error: status === STATUS.ERROR,
      _jobs_data: data,
    };
  },

  async getAllJobs() {
    return await Fetch.get(`${this._main_url}/cronjob/list`);
  },

  async createJob(payload) {
    return await Fetch.post(`${this._main_url}/cronjob/add`, payload);
  },

  async updateJob(payload) {
    return await Fetch.put(`${this._main_url}/cronjob/update`, payload);
  },

  async deleteJob(id) {
    return await Fetch.delete(`${this._main_url}/cronjob/delete?cronjob_id=${id}`);
  },
};

export default cronJobsService;
